import React from 'react';
import { generateBusinessSchemaGraph } from '../utils/businessSchema';

/**
 * LocalBusinessSchema - Main component for business/template pages
 * Uses the FINAL-SCHEMA-99-FIXED structure
 */
export const LocalBusinessSchema = ({ business }) => {
  // Don't render if no valid business data
  if (!business || !business.name || business.name.trim().length < 2) {
    return null;
  }

  const schema = generateBusinessSchemaGraph(business);
  
  if (!schema) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

/**
 * SchemaScript - Generic component (kept for backward compatibility)
 */
export const SchemaScript = ({ type, data }) => {
  if (!data) return null;
  
  if (type === 'business') {
    return <LocalBusinessSchema business={data} />;
  }
  
  // For other types, return null (directory pages handle their own schema)
  return null;
};

/**
 * DirectoryListingSchema - For category/city listing pages
 */
export const DirectoryListingSchema = ({ pageType, pageData, listings }) => {
  // Directory pages already have their own schema in their components
  return null;
};

export default SchemaScript;
